<template>
  <!-- 查看合同  -->
  <div>
     <a-modal
      title="查看"
      :visible="visible"
      @ok="closeFun"
      @cancel="closeFun"
      v-bind="this.$store.state.modalConfig"
      :footer="null"
    >
    <p>合同年度：{{contractYear}}</p>
    <x-tabula
      ref="table"
      rowKey="contractYear"
      :dataSource="dataSource"
      :columns="columns"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="false"
      :paginationParam="false"
    >
    <template slot="opt_t" slot-scope="{row}">
         <a :href="row.fileUrl" target="_blank">{{row.name}}</a>
        </template>
    </x-tabula>
     </a-modal>
  </div>
</template>

<script>
export default {
  components: {},
  data () {
    return {
      visible: false,
      contractYear: undefined,
      columns: [
        {
          title: '版本',
          dataIndex: 'versionDesc',
          align: '',
          width: '200'
        },
        {
          title: '合同名称',
          dataIndex: 'name',
          align: '',
          width: '200',
          scopedSlots: {customRender: 't'}
        },
        {
          title: '状态',
          dataIndex: 'statusDesc',
          align: '',
          width: '200'
        }
      ],
      dataSource: [
      ],
      searchParams: {
      },

      listApi: {
        url: '',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      }

    };
  },

  created () {},
  methods: {
    show (year) {
      this.contractYear = year;
      this.visible = true;
      this.$get({
        url: '/local/contract/annualContractList',
        params: {
          contractYear: year
        }
      }).then((res) => {
        this.dataSource = res.data.rows;
      });
    },
    closeFun () {
      this.visible = false;
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>

<style scoped>
</style>
